import { Component, Prop } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { disableBodyScrolling } from '@/utils/disableBodyScrolling';

@Component
export class MobileMenuTrigger extends ThemeComponent {
    @Prop({default: window.scrollY}) scrollPosition!: number;

    init() {
        // Give initial value for scrollPosition
        this.scrollPosition = window.scrollY;

        // Init click event listeners
        this.initClickEventListener();

        // Init navigation breakpoint check
        this.matchMedia();
    }

    initClickEventListener() {
        this.$listen(this, 'click', () => {

            // Determine whether we are opening are closing
            const closing = document.body.classList.contains('mobile-menu-active');

            // Check mobile menu exists
            const mobileMenu = document.querySelector('.mobile-menu');
            if (!mobileMenu) {
                return;
            }

            // Are we closing?
            if (closing) {

                // Enale body scrolling
                this.scrollPosition = disableBodyScrolling(false, this.scrollPosition);

                // Remove mobile menu child list active classes
                this.removeMobileMenuChildListActiveClasses();

            // No, we're opening
            } else {

                // Disable body scrolling
                this.scrollPosition = disableBodyScrolling(true, this.scrollPosition);
            }

            // Body class
            document.body.classList.toggle('mobile-menu-active');

            // Mobile menu class
            mobileMenu.classList.toggle('mobile-menu--active');

            // Trigger class
            this.classList.toggle('navigation-mobile-menu-toggle--active');
        });
    }

    matchMedia() {
        // Remove mobile menu active active if greater than $navigation-breakpoint
        const mmBreakpoint = window.matchMedia(`(max-width: 950px)`);

        // Check breakpoint, remove mobile menu classes if required
        const breakpointChecker = () => {
            if (!mmBreakpoint.matches) {

                // Only run if filters are active
                if (!document.body.classList.contains('mobile-menu-active')) {
                    return;
                }

                // Check mobile menu exists
                const mobileMenu = document.querySelector('.mobile-menu');
                if (!mobileMenu) {
                    return;
                }

                // Enable scrolling
                this.scrollPosition = disableBodyScrolling(false, this.scrollPosition);

                // Body class
                document.body.classList.remove('mobile-menu-active');

                // Mobile menu class
                mobileMenu.classList.remove('mobile-menu--active');

                // Trigger class
                this.classList.remove('navigation-mobile-menu-toggle--active');

                // Remove mobile menu child list active classes
                this.removeMobileMenuChildListActiveClasses();
            }
        };

        // Init listener and initial check
        breakpointChecker();
        mmBreakpoint.addListener(breakpointChecker);
    }

    removeMobileMenuChildListActiveClasses() {
        // Get active lists
        const selector = '.mobile-menu-list--active:not(.mobile-menu-list--always-active)';
        const activeLists = document.querySelectorAll(selector);

        // Remove active classes
        for (const list of activeLists) {
            list.classList.remove('mobile-menu-list--active');
        }
    }
}
